import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, PLATFORM_ID, ViewChild, Input, ElementRef, LOCALE_ID } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DistributorService } from '../distributors/distributors.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Distributor } from './distributor.model';
import { environment } from '../../environments/environment';
import { voivodeship } from './distributor.model';
import { Settings } from '../shared/navigation/pages.model';
import { shareReplay, Subscription, map, switchMap, catchError, of, Observable, Subject, BehaviorSubject } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
import { debounceTime, take } from 'rxjs/operators';
import { utils } from '../shared/helpers/utils';
import { MapInfoWindow, MapMarker, MapGeocoder, GoogleMap, MapCircle } from '@angular/google-maps';
import { MAP_LOADED } from '../shared/shared.module';
import { isPlatformBrowser } from '@angular/common';
import { UtilsService } from '../shared/services/utils.service';

@Component({
  selector: 'app-distributors',
  templateUrl: 'distributors.component.html',
  styleUrls: ['distributors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class DistributorsComponent implements OnInit, OnDestroy {

  public loading = false;
  public isBrowser = false;
  public isMobile = true;
  public path_contact = '';
  public path_register = '';
  public slug: string;
  public page: any;
  public tabs = [];
  public services = {};
  public sub: Subscription = null;
  public cdn = environment.cdn;
  public settings: Settings = new Settings;
  public voivodeship = voivodeship;
  public zoom = 7;
  public center: BehaviorSubject<any> = new BehaviorSubject({ lat: 52.240371, lng: 19.699272 });
  public options = {};
  public infoTitle = '';
  public infoContent = '';
  public markerInfoSelected;
  

  public postcode = '';
  public focused = false;
  public postcodeChanged = new Subject<string>();
  public addresses: BehaviorSubject<any[]> = new BehaviorSubject([]);
  public radius = 0;
  public geocoderWorking = false;
  public geolocationWorking = false;

  public markers: any[];
  public markers_available: any[] = [];
  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
  @ViewChild('mapwrap', { static: false }) map: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: string, @Inject(MAP_LOADED) public mapLoaded$: Observable<boolean>, @Inject(LOCALE_ID) public localeId: string, public geocoder: MapGeocoder, private router: Router, private route: ActivatedRoute, private distributorsService: DistributorService,
    private navigationService: NavigationService, private utilsService: UtilsService, private cdr: ChangeDetectorRef) {
      this.path_contact = this.router.config.find(x => x?.data.module === 'ContactModule')?.data.path;
      this.path_register = this.router.config.find(x => +x?.data.id === -982)?.path;

        this.navigationService.mobile.subscribe(mobile => {
          this.isMobile = mobile;
        });

        if (isPlatformBrowser(this.platformId)) { 
          this.isBrowser = true;
        }

        this.postcodeChanged.pipe(debounceTime(300)).subscribe(() => {
          if (this.postcode.length > 2) {
            this.geocoder.geocode({
              address: this.postcode
            }).subscribe(({results}) => {
              this.addresses.next(results);
            });
          }
        });
    }

  ngOnInit() {
    this.page = this.route.snapshot.data;
    this.sub = this.navigationService.navigation.subscribe(this.getSettings);
    this.fetchDistributor(0);
  }

  getSettings = (menu: any) => {
    if (Object.keys(menu.menu).length) {
      this.settings = menu.settings;
      this.cdr.markForCheck();
    }
  }
  
  postcodeChange($event) {
    this.postcodeChanged.next($event);
  }

  showDistributors(address: any) {
    var latitude = address.geometry.location.lat();
    var longitude = address.geometry.location.lng();
    this.center.next({ lat: +latitude, lng: +longitude });
    this.filterMarkers(address.geometry.location);
  }

  reset(){}

  getCurrentLocation() {
    if (this.isBrowser) {
      this.loading = true;
      this.geolocationWorking = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.geolocationWorking = false;

          const point: google.maps.LatLngLiteral = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          this.filterMarkers(point);

          this.center.next({ lat: point.lat, lng: point.lng });
          this.loading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          this.geolocationWorking = false;
          this.utilsService.openDialog({isSnackbar: 'warning',
          content: $localize `Nie udało się uzyskać Twojej lokalizacji.`,
          actionButtons: [{ text: 'OK', onAction: () => true }]});
          this.loading = false;
          this.cdr.detectChanges();
        },
        { enableHighAccuracy: true }
      );
    }
  }

  changeRadius(e: MatSelectChange) {
    this.radius = e.value;
    this.filterMarkers(this.center.value);
  }

  filterMarkers(point: any) {
    this.markers.sort((a, b) => {
      var loc1 = new google.maps.LatLng(+a.horizontalalign,+a.verticalalign);
      var loc2 = new google.maps.LatLng(+b.horizontalalign,+b.verticalalign);
      var cpos = google.maps.geometry.spherical.computeDistanceBetween(point, loc1);
      var cpos2 = google.maps.geometry.spherical.computeDistanceBetween(point, loc2);
      if (cpos > cpos2) {
        return 1;
      }
      if (cpos < cpos2) {
        return -1;
      }
      return 0;
    });

    let limit = 0;

    this.markers_available = this.markers.filter((curr) => {
        var loc1 = new google.maps.LatLng(+curr.horizontalalign,+curr.verticalalign);
        var cpos = google.maps.geometry.spherical.computeDistanceBetween(point, loc1);
        if (cpos < this.radius*1000 && this.radius  > 0) {
          return true;
        } else if (this.radius == 0 && limit <= 3) {
          limit++;
          return true;
        }
        return false;
    });

    limit = 0;
    this.tabs.forEach(tab => {
      tab.distributors = this.markers.filter((curr) => {
          var loc1 = new google.maps.LatLng(+curr.horizontalalign,+curr.verticalalign);
          var cpos = google.maps.geometry.spherical.computeDistanceBetween(point, loc1);

          if (cpos < this.radius*1000 && this.radius > 0 && curr.type.includes(''+tab.id)) {
            return true;
          } else if (this.radius == 0 && curr.type.includes(''+tab.id) && limit <= 3) {
            limit++;
            return true;
          }

          return false;
      });
    });
  }

  getVoivodeship(i: number) {
    return this.voivodeship.find((v: any) => +v.value === +i)?.viewValue || '';
  }

  fetchDistributor(v: number) {
    this.distributorsService.items({ voivodeship: v, page: 1, pagesize: 99999 }).pipe(take(1)).subscribe(distributors => {
      if (distributors.items) {
        distributors.types.forEach(s => {
          if (+s.section == 1) {
            if (this.localeId == 'pl') {
              this.tabs.push(s);
            } else {
              if (this.tabs.length == 0) { //only first for non pl
                this.tabs.push(s);
              }
            }
          } else {
            this.services[+s.id] = s;
          }
        })
        this.markers = distributors.items || [];

        this.tabs.forEach(tab => {
          tab.distributors = distributors.items.filter(x => x.type.includes(''+tab.id)) || [];
        });
        this.markers_available = this.tabs[0].items || [];

        if(this.localeId != 'pl') {
          this.getCurrentLocation();
        }

      }
      this.cdr.detectChanges();
    }, error => {
      //error
    });
  }

  changeVoivodeship(e: MatSelectChange) {
    this.fetchDistributor(e.value);
  }

  onTabChanged($event){
    const tab = this.tabs[$event.index];
    this.markers_available = tab.distributors || [];
  }

  goTop() {
    let top = 200;
    if (this.map) {
      top = this.map.nativeElement.offsetTop - 70;
    }
    utils.scrollTo(top, null, 800);
  }

  openInfo(marker: MapMarker, m: any) {

    let content = '<p>' + m.description + '</p>';
    if (m.extra_2) {
      content += '<p><a href="tel:' + m.extra_2 + '">tel. ' + m.extra_2 + '</a></p>';
    }
    if (m.extra_3) {
      content += '<p><a href="tel:' + m.extra_3 + '">tel. ' + m.extra_3 + '</a></p>';
    }

    this.infoTitle = m.title;
    this.infoContent = content;
    this.markerInfoSelected = m;
    this.info.open(marker);
  }

  zoomMarker(id: number, tab_index: number) {
    if (this.isMobile) this.goTop();
    this.zoom = 12;
    let item = this.tabs[tab_index].distributors.find(d => d.id === id);
    if (item) {
      this.center.next({ lat: +item.horizontalalign, lng: +item.verticalalign });
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}
